import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import withTracking from '../../../utils/tracking/components/withTracking';
import { defaultClick } from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';

// External or internal routed link footer item
const linkedItem = PassedComponent => {
  const linkedComponent = props => {
    const { url } = props;
    const mapTrackingToProps = trackEvent => ({
      trackClick: pageObject => trackEvent(defaultClick(pageObject))
    });

    const TrackedPassedComponent = withTracking(mapTrackingToProps)(
      PassedComponent
    );
    if (
      !url.startsWith('https://') &&
      !url.startsWith('http://www.mansueto.com/')
    ) {
      return (
        <TrackedPassedComponent {...props}>
          <Link to={props.url}>
            {props.children && props.children !== ''
              ? props.children
              : props.name}
          </Link>
        </TrackedPassedComponent>
      );
    }
    return (
      <TrackedPassedComponent {...props}>
        <a href={props.url} target="_blank" rel="noopener noreferrer">
          {props.children && props.children !== ''
            ? props.children
            : props.name}
        </a>
      </TrackedPassedComponent>
    );
  };

  linkedComponent.defaultProps = {
    type: {},
    url: '',
    name: '',
    children: {}
  };

  linkedComponent.propTypes = {
    type: PropTypes.func,
    url: PropTypes.string,
    name: PropTypes.string,
    children: PropTypes.node
  };

  return linkedComponent;
};

// Standard text footer item
const DefaultItem = props => {
  const clickProp = {};
  if (props.trackClick !== undefined) {
    clickProp.onClick = () => {
      // [DataLayer] trigger nav item click event
      const clickEvent = new EventModel(
        'Footer Nav Click',
        `footerNav-${props.name}`,
        'footerNav',
        `footerNavigation-${props.name}`,
        props.index + 1
      );
      props.trackClick(clickEvent.getTrackingObject());
    };
  }

  return (
    <li className="footer__link" {...clickProp}>
      {props.children && props.children !== '' ? props.children : props.name}
    </li>
  );
};
DefaultItem.defaultProps = {
  trackClick: () => false,
  url: '',
  type: {},
  name: '',
  index: 1
};
DefaultItem.propTypes = {
  trackClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  url: PropTypes.string,
  type: PropTypes.func,
  name: PropTypes.string,
  index: PropTypes.number
};

const LinkedItem = linkedItem(DefaultItem);

export default class Footer extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const footerItems = [
      {
        name: 'Advertise',
        url:
          'https://images.fastcompany.net/image/upload/v1572457392/fcweb/Mediakit_2019_10.17.19_alrvfp.pdf',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'Privacy Policy',
        url: 'http://www.mansueto.com/privacy-policy',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'Terms',
        url: 'http://www.mansueto.com/terms-of-service',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'Notice of Collection',
        url: 'http://www.mansueto.com/privacy-policy/#collection',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'Do Not Sell My Data',
        url: 'https://fastcompany.zendesk.com/hc/en-us/requests/new',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'Permissions',
        url: 'https://kudos.fastcompany.com',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'Contact',
        url: 'https://www.fastcompany.com/contact-us',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'About Us',
        url: 'https://www.fastcompany.com/about-us',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'Site Map',
        url: '/sitemap',
        type: LinkedItem,
        children: ''
      },
      {
        name: 'Site Info',
        url: '',
        type: DefaultItem,
        children: `Fast Company & Inc © ${new Date().getFullYear()} Mansueto Ventures, LLC`
      },
      {
        name: 'About Ads',
        url: '',
        type: LinkedItem,
        children: (
          <img
            className="footer__daa-logo"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAAAAAC4QtCeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAJ0Uk5TAAB2k804AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAEgAAABIAEbJaz4AAACASURBVAjXYyir3PaDAQby09KL9/2FcjIWf1mbVX0Mwklfw8DwbF5awzkwZzXDjco/j/vTuq+COe93APXcLE5bCeKczvzOwPCoPG0xiHMq6/f9SWkdF4HK1jKcyepJazgFNnrBpwtpVUchRuempR17+htqaU/55l9w5xzf+RHOBgC94zlXyQTR6wAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxMy0wMy0wOFQxOToxMDo0NC0wNTowMNnS5vEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMDMtMDhUMTk6MTA6NDQtMDU6MDCoj15NAAAAAElFTkSuQmCC"
            alt="Digital Advertising Alliance (DAA) Self-Regulatory Program"
            target="_new"
          />
        )
      }
    ];

    return (
      <footer className="footer">
        <nav className="footer__nav-wrapper">
          <ul className="footer__link-container">
            {footerItems.map((item, index) => {
              const ItemComponent = item.type;
              return (
                <ItemComponent key={index} index={index} {...item}>
                  {item.children}
                </ItemComponent>
              );
            })}
          </ul>
        </nav>
      </footer>
    );
  }
}
